import { defineComponent as _defineComponent } from 'vue'
import {
  formatExperiencePeriod,
  formatMonthYear,
  previewHighLightClass
} from '@/utils/format-edit/englishResumePreview'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumePreviewDoc',
  props: {
    formatData: null,
    basicData: null,
    jobsPage1: null,
    fullName: null,
    fullAddress: null,
    fullPhone: null,
    formatedCreateDate: null,
    highlightMessage: null,
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false },
    cardChanged: { type: Boolean, default: false }
  },
  emits: ["go-card-to"],
  setup(__props: any, { emit }: { emit: ({ (e: 'go-card-to', id: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, jobsPage1: any[], fullName: string, fullAddress: string, fullPhone: string, formatedCreateDate: string, highlightMessage: string, currentCardId: string | string[], idPrefix: string, isSample: boolean, cardChanged: boolean };





function goCardTo(id: string) {
  emit('go-card-to', id)
}

function highLightClass(cardId: string | string[]) {
  return previewHighLightClass(
    cardId,
    props.currentCardId,
    !!props.cardChanged,
    !!props.isSample
  )
}

return { __sfc: true,props, emit, goCardTo, highLightClass, formatExperiencePeriod, formatMonthYear }
}

})